export class CommonRecord {
  Antragsdatum: Date = new Date();

  AntragstellerFirma?: string = ""; //*
  Betrieb: string = "";
  Gebaeude: string = ""; //*    

  AntragstellerVorname: string = ""; //*
  AntragstellerNachname: string = ""; //*
  AntragstellerEmail: string = "";          // AntragstellerEMail
  AntragstellerTelefon: string = ""; //*

  AntragstellerIsAnschlussnehmer: boolean;
  AnschlussnehmerVorname: string = "";
  AnschlussnehmerNachname: string = "";
  AnschlussnehmerEmail: string = "";
  AnschlussnehmerTelefon: string = "";

  AntragsVariante: string = "";
  BemerkungAntragsteller: string = "";
  BedarfsterminGeschaetzt: string = "";     // BedarfsterminVoraussichtlichAb  
  KontoEnergieverrechnung: string = ""; //*
}

export class CommonErrors {

  AntragstellerFirma: string = "";
  Betrieb: string = "";
  Gebaeude: string = "";

  AntragstellerVorname: string = "";
  AntragstellerNachname: string = "";
  AntragstellerEmail: string = "";          // AntragstellerEMail
  AntragstellerTelefon: string = "";

  AntragstellerIsAnschlussnehmer: string = "";
  AnschlussnehmerVorname: string = "";
  AnschlussnehmerNachname: string = "";
  AnschlussnehmerEmail: string = "";
  AnschlussnehmerTelefon: string = "";

  AntragsVariante: string = "";
  BemerkungAntragsteller: string = "";
  BedarfsterminGeschaetzt: string = "";     // BedarfsterminVoraussichtlichAb 
  KontoEnergieverrechnung: string = "";
}


export interface ICompany extends IBasic {
  Name: string,
  IstISG: boolean,
}

export interface IVariant {
  Key: string,
  RadioButtonLabel: string,
  AbschnittTitel: string,
}

export interface IBasic {
  Id: number,
  Key: string,
}

export interface IGenericOption {
  key: string,
  text: string,
}

export interface IFormField {
  Id: string,
  Label: string,
  FieldType: string,
  ErrPrefix?: string,
  required: boolean | (() => boolean),           // presently not used to set up controls on SN and RM forms - just for validation
  initialValue?: any,
  used?: boolean | (() => boolean)               // default is true
}


